// This file is generated. Please do not directly make edits to it.
export const designTokens = {
    color: [
        {
            name: 'core-color-black',
            value: '#000000'
        },
        {
            name: 'hsa-color-indigo-600',
            value: '#554492'
        },
        {
            name: 'core-color-white',
            value: '#FFFFFF'
        },
        {
            name: 'fsa-color-blue-900',
            value: '#142745'
        },
        {
            name: 'core-color-red-500',
            value: '#CD3B5F'
        },
        {
            name: 'fsa-color-blue-50',
            value: '#F6FAFF'
        },
        {
            name: 'fsa-color-peach-200',
            value: '#FFB19A'
        },
        {
            name: 'hsa-color-mint-200',
            value: '#BBF3E7'
        },
        {
            name: 'core-color-blue-25',
            value: '#F3F8FF'
        },
        {
            name: 'hsa-color-mint-500',
            value: '#4FCCB1'
        },
        {
            name: 'core-color-grey-900',
            value: '#11181E'
        },
        {
            name: 'fsa-color-peach-100',
            value: '#FFC7B6'
        },
        {
            name: 'core-color-blue-900',
            value: '#142745'
        },
        {
            name: 'fsa-color-blue-700',
            value: '#2375481'
        },
        {
            name: 'fsa-color-blue-600',
            value: '#2458A9'
        },
        {
            name: 'core-color-grey-100',
            value: '#D9D9DD'
        },
        {
            name: 'core-color-transparent',
            value: 'transparent'
        },
        {
            name: 'core-color-grey-200',
            value: '#CCCCCC'
        },
        {
            name: 'hsa-color-indigo-25',
            value: '#FAF1FA'
        },
        {
            name: 'core-color-grey-50',
            value: '#F5F5F5'
        },
        {
            name: 'hsa-color-indigo-50',
            value: '#EAE6FF'
        },
        {
            name: 'core-color-grey-600',
            value: '#666666'
        },
        {
            name: 'fsa-color-yellow-200',
            value: '#FFEA9D'
        },
        {
            name: 'core-color-blue-700',
            value: '#375481'
        },
        {
            name: 'hsa-color-indigo-400',
            value: '#8C7FC0'
        },
        {
            name: 'fsa-color-blue-100',
            value: '#E9F2FF'
        },
        {
            name: 'fsa-color-teal-800',
            value: '#004968'
        },
        {
            name: 'fsa-color-peach-50',
            value: '#FEEBE5'
        },
        {
            name: 'core-color-green-700',
            value: '#127850'
        }
    ],
    shape: [
        {
            name: 'border-radius-100',
            value: '6'
        },
        {
            name: 'border-radius-999',
            value: '999'
        },
        {
            name: 'border-width-200',
            value: '2'
        },
        {
            name: 'border-width-100',
            value: '1'
        },
        {
            name: 'border-radius-25',
            value: '2'
        },
        {
            name: 'border-radius-400',
            value: '24'
        },
        {
            name: 'border-radius-0',
            value: '0'
        },
        {
            name: 'border-width-300',
            value: '3'
        }
    ],
    'font-size': [
        {
            name: 'font-size-250',
            value: '1.875rem'
        },
        {
            name: 'font-size-225',
            value: '1.625rem'
        },
        {
            name: 'font-size-450',
            value: '3.75rem'
        },
        {
            name: 'font-size-120',
            value: '1.125rem'
        },
        {
            name: 'font-size-600',
            value: '5rem'
        },
        {
            name: 'font-size-350',
            value: '2.5rem'
        },
        {
            name: 'font-size-25',
            value: '0.75 rem'
        },
        {
            name: 'font-size-150',
            value: '1.25rem'
        },
        {
            name: 'font-size-700',
            value: '6rem'
        },
        {
            name: 'font-size-400',
            value: '3rem'
        },
        {
            name: 'font-size-375',
            value: '2.75rem'
        },
        {
            name: 'font-size-15',
            value: '0.688 rem'
        },
        {
            name: 'font-size-550',
            value: '4.5rem'
        },
        {
            name: 'font-size-200',
            value: '1.5rem'
        },
        {
            name: 'font-size-50',
            value: '0.875rem'
        },
        {
            name: 'font-size-10',
            value: '0.625 rem'
        },
        {
            name: 'font-size-420',
            value: '3.5rem'
        },
        {
            name: 'font-size-300',
            value: '2rem'
        },
        {
            name: 'font-size-100',
            value: '1rem'
        },
        {
            name: 'font-size-320',
            value: '2.25rem'
        }
    ],
    'letter-spacing': [
        {
            name: 'letter-spacing-tight',
            value: '-0.005em'
        },
        {
            name: 'letter-spacing-tighter',
            value: '-0.0125em'
        },
        {
            name: 'letter-spacing-widest',
            value: '0.04em'
        },
        {
            name: 'letter-spacing-tightest',
            value: '-0.02em'
        },
        {
            name: 'letter-spacing-wide',
            value: '0.0125em'
        },
        {
            name: 'letter-spacing-wider',
            value: '0.02em'
        }
    ],
    dimensions: [
        {
            name: 'dimensions-100',
            value: '4'
        },
        {
            name: 'dimensions-1800',
            value: '72'
        },
        {
            name: 'dimensions-1500',
            value: '60'
        },
        {
            name: 'dimensions-800',
            value: '32'
        },
        {
            name: 'dimensions-1000',
            value: '40'
        },
        {
            name: 'dimensions-2400',
            value: '96'
        },
        {
            name: 'dimensions-0',
            value: '0'
        },
        {
            name: 'dimensions-150',
            value: '6'
        },
        {
            name: 'dimensions-600',
            value: '24'
        },
        {
            name: 'dimensions-900',
            value: '36'
        },
        {
            name: 'dimensions-200',
            value: '8'
        },
        {
            name: 'dimensions-1400',
            value: '56'
        },
        {
            name: 'dimensions-500',
            value: '20'
        },
        {
            name: 'dimensions-2200',
            value: '86'
        },
        {
            name: 'dimensions-1300',
            value: '52'
        },
        {
            name: 'dimensions-1600',
            value: '64'
        },
        {
            name: 'dimensions-1700',
            value: '68'
        },
        {
            name: 'dimensions-050',
            value: '2'
        },
        {
            name: 'dimensions-1200',
            value: '48'
        },
        {
            name: 'dimensions-400',
            value: '16'
        },
        {
            name: 'dimensions-700',
            value: '28'
        },
        {
            name: 'dimensions-1900',
            value: '76'
        },
        {
            name: 'dimensions-2100',
            value: '84'
        },
        {
            name: 'dimensions-1100',
            value: '44'
        },
        {
            name: 'dimensions-300',
            value: '12'
        },
        {
            name: 'dimensions-2300',
            value: '92'
        }
    ],
    'font-weight': [
        {
            name: 'font-weight-black',
            value: '700'
        },
        {
            name: 'font-weight-medium',
            value: '500'
        },
        {
            name: 'font-weight-regular',
            value: '400'
        },
        {
            name: 'font-weight-bold',
            value: '600'
        },
        {
            name: 'font-weight-ultralight',
            value: '200'
        },
        {
            name: 'font-weight-light',
            value: '300'
        }
    ],
    'font-family': [
        {
            name: 'font-family-hsa',
            value: 'WT Volkolak Serif'
        },
        {
            name: 'font-family-core',
            value: 'WT Volkolak Grotesque'
        },
        {
            name: 'font-family-fsa',
            value: 'WT Volkolak Sans Display'
        }
    ],
    'line-height': [
        {
            name: 'line-height-relative-600',
            value: '1.6'
        },
        {
            name: 'line-height-relative-300',
            value: '1.2'
        }
    ]
}
